<template>
  <a-card :bordered="false">
    <div>
      <!-- 查询区域 -->
      <div class="table-page-search-wrapper">
        <a-form layout="inline" @keyup.enter.native="searchQuery">
          <a-row :gutter="24">
            <a-col :md="8" :sm="12">
              <a-form-item label="选择渠道">
                <a-select
                  v-model="queryParam.channelCode"
                  placeholder="请选择渠道"
                  style="width: 200px;margin-left: auto"
                  @change="handleChange"
                >
                  <a-select-option
                    v-for="(item, index) in wechatAppList"
                    :key="item.appId"
                    :value="index"
                    >{{ item.name }}</a-select-option
                  >
                </a-select>
              </a-form-item>
            </a-col>
            <a-col :md="6" :sm="8">
              <span
                style="float: left;overflow: hidden;"
                class="table-page-search-submitButtons"
              >
                <a-button type="primary" @click="searchQuery" icon="search"
                  >查询</a-button
                >
              </span>
            </a-col>
          </a-row>
        </a-form>
      </div>
      <!-- 查询区域-END -->
      <!--<JAreaLinkage type="select"></JAreaLinkage>-->
      <!-- 按钮区域 -->
      <div>
        <a-button
          v-if="wechatApp.type == 1 || wechatApp.type == 2"
          @click="syncUser"
          >粉丝同步</a-button
        >
        <a-button @click="exportExcel">批量导出</a-button>
        <a-upload
          v-if="wechatApp.type == 3"
          name="file"
          :showUploadList="false"
          :multiple="false"
          :fileList="fileList"
          :before-upload="beforeUpload"
          @transformFile="importExcel"
        >
          <a-button
            type="primary"
            icon="import"
            :loading="load"
            :disabled="load"
            >导入</a-button
          >
        </a-upload>
        <a-button
          v-if="channelInfo.code"
          @click="groupUser"
          :disabled="this.dataListSelections.length <= 0"
          >用户分组</a-button
        >
        <a-button
          v-if="wechatApp.type == 1 || wechatApp.type == 2"
          :disabled="this.dataListSelections.length <= 0"
          @click="tagUser"
          >打标签</a-button
        >
        <a-button
          v-if="wechatApp.type == 1 || wechatApp.type == 2"
          :disabled="this.dataListSelections.length <= 0"
          @click="addBlack"
          >加入黑名单</a-button
        >
        <a-button @click="searchModal">筛选</a-button>
        <a-button
          v-if="wechatApp.type == 1 || wechatApp.type == 2"
          style="float: right"
          @click="blackUser"
          >黑名单用户</a-button
        >
      </div>
      <!-- 按钮区域END -->

      <!-- 查询区域 -->
      <a-modal
        title="筛选"
        :visible="searchVisible"
        @cancel="HandleCancel"
        @ok="searchHandleOk"
        width="1000px"
      >
        <a-form layout="inline" @keyup.enter.native="searchQuery">
          <a-form-item label="openId">
            <a-input
              placeholder="请输入openId"
              v-model="queryParams.openId"
            ></a-input>
          </a-form-item>
          <a-form-item label="昵称">
            <a-input
              placeholder="请输入昵称"
              v-model="queryParams.nickName"
            ></a-input>
          </a-form-item>
          <a-form-item
            label="性别"
            v-if="wechatApp.type == 1 || wechatApp.type == 2"
          >
            <a-select
              v-model="queryParams.sex"
              placeholder="请选择性别"
              style="width: 120px"
            >
              <a-select-option value="1">男</a-select-option>
              <a-select-option value="2">女</a-select-option>
              <a-select-option value="0">未知</a-select-option>
            </a-select>
          </a-form-item>
          <a-form-item label="性别" v-if="wechatApp.type == 3">
            <a-select
              v-model="queryParams.sex"
              placeholder="请选择性别"
              style="width: 120px"
            >
              <a-select-option value="1.0">男</a-select-option>
              <a-select-option value="2.0">女</a-select-option>
              <a-select-option value="0.0">未知</a-select-option>
            </a-select>
          </a-form-item>
          <a-form-item label="手机号" v-if="wechatApp.type == 3">
            <a-input
              placeholder="请输入手机号"
              v-model="queryParams.phone"
            ></a-input>
          </a-form-item>
          <a-form-item label="地区">
            <a-cascader
              v-model="queryParams.area"
              :field-names="{ label: 'name', value: 'name', children: 'sub' }"
              :options="areaOptions"
              placeholder="请选择地区"
              change-on-select
              @change="onChange"
            ></a-cascader>
          </a-form-item>
          <a-form-item
            label="标签"
            v-if="wechatApp.type == 1 || wechatApp.type == 2"
          >
            <a-select
              mode="tags"
              placeholder="请选择标签"
              @change="handleChangeTag"
              style="width: 120px"
            >
              <a-select-option
                v-for="item in tagListAll"
                :key="item.id.toString()"
              >
                {{ item.name }}
              </a-select-option>
            </a-select>
          </a-form-item>
          <a-form-item label="关注时间/创建时间">
            <a-range-picker :value="createValue" @change="createChange" />
          </a-form-item>
          <a-form-item
            label="积分"
            v-if="
              (wechatApp.type == 3) & (channelInfo.code == 'integral_miniapp')
            "
          >
            <a-input
              oninput="if(this.value=='00'){this.value='0';}else{this.value=this.value.replace(/[^0-9]/g,'')};"
              style="width: 70px;margin-left: auto"
              placeholder="请输入人数范围"
              v-model="queryParams.numStart"
            ></a-input>
            <a>~</a>
            <a-input
              oninput="if(this.value=='00'){this.value='0';}else{this.value=this.value.replace(/[^0-9]/g,'')};"
              style="width: 70px;margin-left: auto"
              placeholder="请输入人数范围"
              v-model="queryParams.numEnd"
            ></a-input>
          </a-form-item>
        </a-form>
      </a-modal>
      <!-- 查询区域-END -->

      <!-- 表格区域 -->
      <div style="margin-top: 10px">
        <a-table
          v-if="wechatApp.type == 1 || wechatApp.type == 2"
          ref="table"
          size="middle"
          :rowKey="record => record.openid"
          :columns="columns"
          :dataSource="userList"
          :row-selection="{
            selectedRowKeys: dataListSelections,
            onChange: onSelectChange
          }"
          class="j-table-force-nowrap"
          :pagination="userPagination"
          @change="userHandleTableChange"
        >
          <template slot="headimgurlslot" slot-scope="text, record, index">
            <div class="anty-img-wrap">
              <a-avatar
                shape="square"
                :src="getHeadImageView(record.headimgurl)"
                icon="user"
              />
            </div>
          </template>
          <template slot="sexslot" slot-scope="text, record, index">
            <span v-if="record.sex === 1">男</span>
            <span v-if="record.sex === 2">女</span>
            <span v-if="record.sex === 0">未知</span>
          </template>
          <template slot="tagslot" slot-scope="text, record, index">
            <span>{{ getTagName(record.tagidList) }}</span>
          </template>
          <span slot="action" slot-scope="text, record">
            <a style="margin-left: 10px" @click="viewModal(record)">查看</a>
            <a style="margin-left: 10px" @click="deleteUser(record.openid)"
              >删除</a
            >
          </span>
        </a-table>

        <a-table
          v-if="wechatApp.type == 3"
          ref="table"
          size="middle"
          :rowKey="record => record.id"
          :columns="columnMiniApp"
          :dataSource="userList"
          :row-selection="{
            selectedRowKeys: dataListSelections,
            onChange: onSelectChange
          }"
          class="j-table-force-nowrap"
          :pagination="userPagination"
          @change="userHandleTableChange"
        >
          <template slot="headimgurlslot" slot-scope="text, record, index">
            <div class="anty-img-wrap">
              <a-avatar
                shape="square"
                :src="getHeadImageView(record.avatarUrl)"
                icon="user"
              />
            </div>
          </template>
          <template slot="sexslot" slot-scope="text, record, index">
            <span v-if="record.gender == 1.0">男</span>
            <span v-if="record.gender == 2.0">女</span>
            <span v-if="record.gender == 0.0">未知</span>
          </template>
          <span slot="action" slot-scope="text, record">
            <a style="margin-left: 10px" @click="viewModal(record)">查看</a>
            <a style="margin-left: 10px" @click="deleteUser(record.id)">删除</a>
          </span>
        </a-table>
      </div>
      <!-- 表格区域END -->

      <!-- 标签区域 -->
      <a-modal
        title="可选标签"
        :visible="tagVisible"
        @cancel="HandleCancel"
        @ok="tagHandleOk"
        width="1000px"
      >
        <a-table
          ref="table"
          size="middle"
          rowKey="id"
          :columns="columnTag"
          :dataSource="tagListAll"
          class="j-table-force-nowrap"
          :row-selection="{
            selectedRowKeys: tagListSelections,
            onChange: tagSelectChange
          }"
        >
        </a-table>
      </a-modal>
      <!-- 标签区域END -->

      <!-- 分组区域 -->
      <a-modal
        title="可选分组"
        :visible="groupVisible"
        @cancel="HandleCancel"
        @ok="groupHandleOk"
        width="1000px"
      >
        <a-table
          ref="table"
          size="middle"
          rowKey="id"
          :columns="columnGroup"
          :dataSource="groupListAll"
          class="j-table-force-nowrap"
          :row-selection="{
            selectedRowKeys: groupListSelections,
            onChange: groupSelectChange
          }"
        >
        </a-table>
      </a-modal>
      <!-- 分组区域END -->

      <!-- 黑名单区域 -->
      <a-modal
        title="黑名单用户"
        :visible="blackVisible"
        width="1000px"
        @cancel="HandleCancel"
      >
        <a-button @click="syncBlackUser" style="margin: 10px"
          >黑名单同步</a-button
        >
        <a-table
          ref="table"
          size="middle"
          :rowKey="record => record.openid"
          :columns="columnBlack"
          :dataSource="blackUserList"
          :row-selection="{
            selectedRowKeys: blackDataListSelections,
            onChange: blackSelectChange
          }"
          class="j-table-force-nowrap"
          :pagination="blackPagination"
          @change="blackHandleTableChange"
        >
          <template slot="headimgurlslot" slot-scope="text, record, index">
            <div class="anty-img-wrap">
              <a-avatar
                shape="square"
                :src="getHeadImageView(record.headimgurl)"
                icon="user"
              />
            </div>
          </template>
          <template slot="sexslot" slot-scope="text, record, index">
            <span v-if="record.sex === 1">男</span>
            <span v-if="record.sex === 2">女</span>
            <span v-if="record.sex === 0">未知</span>
          </template>
          <template slot="tagslot" slot-scope="text, record, index">
            <span>{{ getTagName(record.tagidList) }}</span>
          </template>
        </a-table>
        <template slot="footer">
          <a-button type="" @click="HandleCancel">
            取消
          </a-button>
          <a-button
            type="primary"
            :disabled="this.blackDataListSelections.length <= 0"
            @click="blackHandleOk"
          >
            移出黑名单
          </a-button>
        </template>
      </a-modal>
      <!-- 黑名单区域END -->

      <!-- 查看区域 -->
      <a-modal
        title="查看"
        :visible="viewVisible"
        @cancel="HandleCancel"
        width="1000px"
      >
        <a-row type="flex" justify="space-around" align="middle">
          <a-col :span="4">
            <p class="height-100">
              <img :src="getHeadImageView(this.userInfo.headimgurl)" />
            </p>
          </a-col>
          <a-col :span="12">
            <a-row>
              <a-col :span="12"> 昵称: {{ this.userInfo.nickname }} </a-col>
              <a-col :span="12"> 性别: {{ this.userInfo.sex }} </a-col>
            </a-row>
            <a-row>
              <a-col :span="12">
                地区: {{ this.userInfo.country }} {{ this.userInfo.province }}
                {{ this.userInfo.city }}
              </a-col>
              <a-col :span="12" v-if="this.userInfo.subscribeTime">
                关注时间: {{ this.userInfo.subscribeTime }}
              </a-col>
              <a-col :span="12" v-if="this.userInfo.phone">
                手机号: {{ this.userInfo.phone }}
              </a-col>
            </a-row>
            <a-row>
              <a-col :span="12"> unionid: {{ this.userInfo.unionid }} </a-col>
              <a-col :span="12" v-if="this.userInfo.tagidList">
                标签: {{ this.userInfo.tagidList }}
              </a-col>
              <a-col :span="12" v-if="this.userInfo.createTime">
                创建时间: {{ this.userInfo.createTime }}
              </a-col>
            </a-row>
          </a-col>
        </a-row>
      </a-modal>
      <!-- 查看区域END -->
    </div>
  </a-card>
</template>

<script>
import channelSearch from '@/components/wechat/channelSearch';
import {
  getAction,
  postAction,
  getFileAccessHttpUrl,
  downloadFile,
  uploadAction
} from '@/api/manage';
import '@/assets/less/TableExpand.less';
import { mixinDevice } from '@/utils/mixin';
import JInput from '@/components/jeecg/JInput';
import { areaList } from '@/utils/area';
export default {
  mixins: [mixinDevice],
  components: {
    JInput,
    channelSearch
  },
  data() {
    return {
      load: false,
      createValue: [],
      fileList: [],
      userList: [],
      userInfo: {},
      blackUserList: [],
      dataSelect: [],
      tagListAll: [],
      groupListAll: [],
      wechatAppList: [],
      wechatApp: {},
      channelInfo: {},
      queryParam: {},
      queryParams: {},
      tagContent: [],
      tagVisible: false,
      groupVisible: false,
      blackVisible: false,
      viewVisible: false,
      searchVisible: false,
      wechatAppId: '',
      areaOptions: areaList,
      dataListSelections: [],
      tagListSelections: [],
      blackDataListSelections: [],
      groupListSelections: [],
      userPagination: {
        total: 0,
        pageSize: 10, //每页中显示10条数据
        showSizeChanger: true,
        pageSizeOptions: ['10', '20', '30'], //每页中显示的数据
        showTotal: total => `共有 ${total} 条数据` //分页中显示总的数据
      },
      userPageIndex: 1,
      userPageSize: 10,
      blackPagination: {
        total: 0,
        pageSize: 10, //每页中显示10条数据
        showSizeChanger: true,
        pageSizeOptions: ['10', '20', '30'], //每页中显示的数据
        showTotal: total => `共有 ${total} 条数据` //分页中显示总的数据
      },
      blackPageIndex: 1,
      blackPageSize: 10,
      columns: [
        {
          title: 'openId',
          dataIndex: 'openid',
          align: 'center',
          key: 'openid'
        },
        {
          title: '昵称',
          dataIndex: 'nickname',
          align: 'center',
          key: 'nickname'
        },
        {
          title: '头像',
          dataIndex: 'headimgurl',
          align: 'center',
          key: 'headimgurl',
          width: 120,
          scopedSlots: { customRender: 'headimgurlslot' }
        },
        {
          title: '性别',
          dataIndex: 'sex',
          align: 'center',
          key: 'sex',
          scopedSlots: { customRender: 'sexslot' }
        },
        {
          title: '地区',
          dataIndex: 'city',
          align: 'center',
          key: 'city'
        },
        {
          title: '标签',
          dataIndex: 'tagidList',
          align: 'center',
          key: 'tagidList',
          scopedSlots: { customRender: 'tagslot' }
        },
        {
          title: '关注时间',
          dataIndex: 'subscribeTime',
          align: 'center',
          key: 'subscribeTime'
        },
        {
          title: '操作',
          dataIndex: 'action',
          align: 'center',
          // fixed:"right",
          width: 147,
          scopedSlots: { customRender: 'action' }
        }
      ],
      columnTag: [
        {
          title: '标签ID',
          dataIndex: 'id',
          key: 'id'
        },
        {
          title: '标签名称',
          dataIndex: 'name',
          key: 'name'
        }
      ],
      columnGroup: [
        {
          title: '分组ID',
          dataIndex: 'id',
          key: 'id'
        },
        {
          title: '分组名称',
          dataIndex: 'groupName',
          key: 'groupName'
        },
        {
          title: '分组描述',
          dataIndex: 'groupDesc',
          key: 'groupDesc'
        }
      ],
      columnBlack: [
        {
          title: 'openId',
          dataIndex: 'openid',
          align: 'center',
          key: 'openid'
        },
        {
          title: '昵称',
          dataIndex: 'nickname',
          align: 'center',
          key: 'nickname'
        },
        {
          title: '头像',
          dataIndex: 'headimgurl',
          align: 'center',
          key: 'headimgurl',
          width: 120,
          scopedSlots: { customRender: 'headimgurlslot' }
        },
        {
          title: '性别',
          dataIndex: 'sex',
          align: 'center',
          key: 'sex',
          scopedSlots: { customRender: 'sexslot' }
        },
        {
          title: '地区',
          dataIndex: 'city',
          align: 'center',
          key: 'city'
        },
        {
          title: '标签',
          dataIndex: 'tagidList',
          align: 'center',
          key: 'tagidList',
          scopedSlots: { customRender: 'tagslot' }
        },
        {
          title: '关注时间',
          dataIndex: 'subscribeTime',
          align: 'center',
          key: 'subscribeTime'
        }
      ],
      columnMiniApp: [
        {
          title: 'openId',
          dataIndex: 'openId',
          align: 'center',
          key: 'openId'
        },
        {
          title: '昵称',
          dataIndex: 'nickName',
          align: 'center',
          key: 'nickName'
        },
        {
          title: '头像',
          dataIndex: 'avatarUrl',
          align: 'center',
          key: 'avatarUrl',
          width: 120,
          scopedSlots: { customRender: 'headimgurlslot' }
        },
        {
          title: '性别',
          dataIndex: 'gender',
          align: 'center',
          key: 'gender',
          scopedSlots: { customRender: 'sexslot' }
        },
        {
          title: '地区',
          dataIndex: 'city',
          align: 'center',
          key: 'city'
        },
        {
          title: '手机号',
          dataIndex: 'phone',
          align: 'center',
          key: 'phone'
        },
        {
          title: '创建时间',
          dataIndex: 'createTime',
          align: 'center',
          key: 'createTime'
        },
        {
          title: '操作',
          dataIndex: 'action',
          align: 'center',
          // fixed:"right",
          width: 147,
          scopedSlots: { customRender: 'action' }
        }
      ]
    };
  },
  created() {
    this.getAppAll();
  },
  methods: {
    //筛选
    searchModal() {
      this.searchVisible = true;
    },
    onChange(checked) {
      if (checked.length == 3) {
        this.queryParams.city = checked[2];
        this.queryParams.province = checked[1];
      }
      if (checked.length == 2) {
        this.queryParams.province = checked[1];
      }
      this.queryParams.country = checked[0];
      console.log(`a-switch to ${checked}`);
    },
    handleChangeTag(value) {
      this.queryParams.tagIds = `${value}`;
      console.log(this.dataSelect);
    },
    createChange(dates, dateStrings) {
      this.createValue = dates;
      this.queryParams.startTime = dateStrings[0];
      this.queryParams.endTime = dateStrings[1];
    },
    //获取所有渠道
    getAppAll() {
      getAction(process.env.VUE_APP_CMS_WECHAT + '/wechatApp/queryByType', {
        type: '1,2,3'
      }).then(res => {
        if (res.success) {
          this.wechatAppList = res.result;
        }
      });
    },
    //获取标签
    getTagListAll() {
      getAction(process.env.VUE_APP_CMS_WECHAT + '/manage/wxUserTags/listAll', {
        appid: this.wechatApp.appId
      }).then(res => {
        if (res.success && res.code === 200) {
          this.tagListAll = res.result;
        } else {
          this.$message.error(res.message);
        }
      });
    },
    //获取分组
    getGroupListAll() {
      getAction(process.env.VUE_APP_CMS_WECHAT + '/wechatGroup/list', {
        channelCode: this.channelInfo.code ? this.channelInfo.code : ''
      }).then(res => {
        if (res.success && res.code === 200) {
          this.groupListAll = res.result;
        } else {
          this.$message.error(res.message);
        }
      });
    },
    //渠道下拉框选择
    handleChange(item) {
      this.userList = [];
      this.wechatApp = this.wechatAppList[item];
      getAction(process.env.VUE_APP_CMS_SYSTEM + '/sys/channel/queryByAppId', {
        appId: this.wechatApp.appId
      }).then(res => {
        if (res.success) {
          this.channelInfo = res.result;
          this.userList = [];
          this.userPageIndex = 1;
        } else {
          this.channelInfo = {};
        }
      });
      console.log(this.channelInfo);
      console.log(item);
    },
    //同步粉丝
    syncUser() {
      postAction(process.env.VUE_APP_CMS_WECHAT + '/wxUser/syncWxUsers', {
        appId: this.wechatApp.appId
      }).then(res => {
        if (res.success && res.code === 200) {
          this.$message.success('同步任务已经建立,请稍后刷新页面查看列表');
        } else {
          this.$message.error(res.message);
        }
      });
    },
    //同步黑名单粉丝
    syncBlackUser() {
      postAction(process.env.VUE_APP_CMS_WECHAT + '/wxUser/syncWxBlackUsers', {
        appId: this.wechatApp.appId
      }).then(res => {
        if (res.success && res.code === 200) {
          this.$message.success('同步任务已经建立,请稍后刷新页面查看列表');
        } else {
          this.$message.error(res.message);
        }
      });
    },
    //添加黑名单
    addBlack() {
      postAction(process.env.VUE_APP_CMS_WECHAT + '/wxUser/addBlack', {
        appid: this.wechatApp.appId,
        openIds: this.dataListSelections.join(',')
      }).then(res => {
        if (res.success && res.code === 200) {
          this.$message.success(res.message);
        } else {
          this.$message.error(res.message);
        }
      });
      this.searchQuery();
    },
    //打标签modal
    tagUser() {
      this.tagVisible = true;
    },
    //筛选确定
    searchHandleOk() {
      console.log(this.queryParams);
      console.log('ok');
      this.searchQuery();
    },
    //打标签modal确定
    tagHandleOk(e) {
      postAction(
        process.env.VUE_APP_CMS_WECHAT + `/manage/wxUserTags/batchTaggingUsers`,
        {
          appid: this.wechatApp.appId,
          tagIds: this.tagListSelections.join(','),
          openIds: this.dataListSelections.join(',')
        }
      ).then(res => {
        if (res.success && res.code === 200) {
          this.$message.success(res.message);
        } else {
          this.$message.error(res.message);
        }
        this.dataListSelections = [];
        this.tagListSelections = [];
        this.tagVisible = false;
      });
      this.searchQuery();
    },
    //modal取消
    HandleCancel(e) {
      this.tagVisible = false;
      this.groupVisible = false;
      this.blackVisible = false;
      this.viewVisible = false;
      this.searchVisible = false;
      this.queryParams = {};
      this.createValue = [];
    },
    //分组modal
    groupUser() {
      this.groupVisible = true;
    },
    //加入分组
    groupHandleOk(e) {
      postAction(process.env.VUE_APP_CMS_WECHAT + `/wechatGroup/addGroupUser`, {
        groupIds: this.groupListSelections.join(','),
        userIds: this.dataListSelections.join(','),
        channelCode: this.channelInfo.code
      }).then(res => {
        if (res.success && res.code === 200) {
          this.$message.success(res.message);
        } else {
          this.$message.error(res.message);
        }
        this.groupListSelections = [];
        this.dataListSelections = [];
        this.groupVisible = false;
      });
    },
    //黑名单modal
    blackUser() {
      this.blackVisible = true;
      getAction(process.env.VUE_APP_CMS_WECHAT + '/wxUser/list', {
        appId: this.wechatApp.appId,
        channelCode: this.channelInfo.code ? this.channelInfo.code : '',
        type: this.wechatApp.type,
        blackFlag: 1,
        pageNo: this.blackPageIndex,
        pageSize: this.blackPageSize
      }).then(res => {
        if (res.success && res.code === 200) {
          this.blackUserList = res.result.records;
          //this.pagination.total = res.result.totalCount
        } else {
          this.blackUserList = [];
          //this.totalCount = 0
        }
        //this.dataListLoading = false
      });
    },
    //移出黑名单
    blackHandleOk(e) {
      postAction(process.env.VUE_APP_CMS_WECHAT + '/wxUser/pullBlack', {
        appid: this.wechatApp.appId,
        openIds: this.blackDataListSelections.join(',')
      }).then(res => {
        if (res.success && res.code === 200) {
          this.$message.success(res.message);
        } else {
          this.$message.error(res.message);
        }
        this.blackDataListSelections = [];
        this.blackVisible = false;
      });
      this.searchQuery();
    },
    init(data) {
      this.wechatAppId = data;
      this.getDataList();
      this.getTagList();
    },
    //用户选择
    onSelectChange(selectedRowKeys) {
      this.dataListSelections = selectedRowKeys;
      console.log(this.dataListSelections);
    },
    //标签选择
    tagSelectChange(selectedRowKeys) {
      this.tagListSelections = selectedRowKeys;
      console.log(this.tagListSelections);
    },
    //黑名单选择
    blackSelectChange(selectedRowKeys) {
      this.blackDataListSelections = selectedRowKeys;
      console.log(this.blackDataListSelections);
    },
    //分组选择
    groupSelectChange(selectedRowKeys) {
      this.groupListSelections = selectedRowKeys;
      console.log(this.groupListSelections);
    },
    getHeadImageView: function(headimgurl) {
      return getFileAccessHttpUrl(headimgurl);
    },
    // 获取数据列表
    searchQuery() {
      this.userList = [];
      this.dataListSelections = [];
      if (this.wechatApp.type !== 3) {
        this.getTagListAll();
      }
      this.getGroupListAll();
      getAction(process.env.VUE_APP_CMS_WECHAT + '/wxUser/list', {
        appId: this.wechatApp.appId,
        channelCode: this.channelInfo.code ? this.channelInfo.code : '',
        type: this.wechatApp.type,
        blackFlag: 0,
        pageNo: this.userPageIndex,
        pageSize: this.userPageSize,
        ...this.queryParams
      }).then(res => {
        if (res.success && res.code === 200) {
          console.log(res.result.records);
          this.userList = res.result.records;
          this.userPagination.total = res.result.total;
          this.searchVisible = false;
        } else {
          this.$message.error(res.message);
          this.userList = [];
          this.totalCount = 0;
        }
        //this.dataListLoading = false
      });
    },
    //标签名称
    getTagName(tagidList) {
      let userTag = tagidList
        .split('[')[1]
        .split(']')[0]
        .split(',');
      let userTagContent = '';
      for (let i in userTag) {
        for (let j in this.tagListAll) {
          if (userTag[i] == this.tagListAll[j].id) {
            userTagContent += this.tagListAll[j].name + ',';
          }
        }
      }
      if (userTagContent.length > 0) {
        userTagContent = userTagContent.substr(0, userTagContent.length - 1);
      }
      return userTagContent;
    },
    userHandleTableChange(pagination) {
      //const page = { ...this.userPagination };
      this.userPagination.current = pagination.current;
      this.userPagination.pageSize = pagination.pageSize;
      this.userPageIndex = pagination.current;
      this.userPageSize = pagination.pageSize;
      this.userPagination = pagination;
      this.searchQuery();
    },
    blackHandleTableChange(pagination) {
      //const page = { ...this.userPagination };
      this.blackPagination.current = pagination.current;
      this.blackPagination.pageSize = pagination.pageSize;
      this.blackPageIndex = pagination.current;
      this.blackPageSize = pagination.pageSize;
      this.blackPagination = pagination;
      this.blackUser();
    },
    deleteUser(id) {
      postAction(process.env.VUE_APP_CMS_WECHAT + '/wxUser/delete', {
        id: id,
        type: this.wechatApp.type
      }).then(res => {
        if (res.success && res.code === 200) {
          this.$message.success(res.message);
          this.searchQuery();
        } else {
          this.$message.error(res.message);
        }
      });
    },
    //查看
    viewModal(record) {
      this.userInfo = { ...record };
      this.userInfo.headimgurl = !record.avatarUrl
        ? record.headimgurl
        : record.avatarUrl;
      this.userInfo.nickname = !record.nickName
        ? record.nickname
        : record.nickName;
      this.userInfo.sex = !record.gender ? record.sex : record.gender;
      if (this.userInfo.sex == 1 || this.userInfo.sex == 1.0) {
        this.userInfo.sex = '男';
      }
      if (this.userInfo.sex == 2 || this.userInfo.sex == 2.0) {
        this.userInfo.sex = '女';
      }
      if (this.userInfo.sex == 0 || this.userInfo.sex == 0.0) {
        this.userInfo.sex = '未知';
      }
      console.log(this.userInfo);
      this.viewVisible = true;
    },
    //导出excel
    exportExcel() {
      downloadFile(
        process.env.VUE_APP_CMS_WECHAT + '/wechatUser/exportXls',
        '用户信息.xls',
        {
          type: this.wechatApp.type,
          userIds: this.dataListSelections.join(',')
        }
      ).then(res => {});
    },
    importExcel(file) {
      console.log('fileList', file);
      let formData = new FormData();
      formData.put('file', null);
      uploadAction(process.env.VUE_APP_CMS_WECHAT + '/wechatUser/importExcel', {
        formData,
        appId: this.wechatApp.appId
      }).then(res => {});
    },
    beforeUpload(file) {
      this.load = true;
      console.log('file: ', file);
      let formData = new FormData();
      formData.set('file', file);
      uploadAction(
        process.env.VUE_APP_CMS_WECHAT +
          '/wechatUser/importExcel/' +
          this.wechatApp.appId,
        formData
      )
        .then(res => {
          if (res.success) {
            this.$message.success(res.message);
          } else {
            this.$message.error(res.message);
          }
        })
        .finally(() => {
          this.load = false;
        });
    }
  }
};
</script>
<style lang="less" scoped>
//@import '~@assets/less/common.less'
/** Button按钮间距 */
.ant-btn {
  margin-left: 10px;
}
</style>
